import {styled} from '@mui/material/styles';
import {Button} from '@mui/material';

export const GridLinkButton = styled(Button)(({})=>({
    'width': '100%',
    'height': '100%',
    'minWidth': 0,
    'padding': 0,
    'margin': 0,
    'justifyContent': 'flex-start',
    'textTransform': 'none',
    '&:hover': {
        backgroundColor: 'transparent',
    },
}));
